var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 15" }, props),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-success"] || "oc-icon-status-success"), d: "M9.6 5.4c1.8 1.8 1.7 4.6 0 6.3l-2 2c-1.7 1.7-4.6 1.7-6.3 0-1.7-1.7-1.7-4.6 0-6.3l1.1-1.1c.3-.3.8-.1.8.3 0 .5.1 1 .3 1.5.1.2 0 .4-.1.5L3 9c-.8.8-.8 2.2 0 3 .8.8 2.2.8 3 0l2-2c.8-.8.8-2.2 0-3-.2 0-.3-.1-.4-.2-.1 0-.2-.2-.2-.3 0-.3.1-.6.3-.9l.7-.6c.1-.2.4-.2.6-.1.2.2.4.3.6.5zm4.1-4.1C12-.4 9.1-.4 7.4 1.3l-2 2C3.7 5 3.7 7.8 5.4 9.6c.2.2.4.3.6.5.2.1.4.1.6-.1l.6-.6c.2-.2.4-.6.3-.9 0-.1-.1-.3-.2-.4l-.2-.2c-.8-.8-.8-2.2 0-3l2-2c.8-.8 2.2-.8 3 0 .8.8.8 2.2 0 3l-.4.4c-.1.1-.2.3-.1.5.2.5.3 1 .3 1.5 0 .4.5.6.8.3l1.1-1.1c1.6-1.6 1.6-4.5-.1-6.2z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Matched.svg